<template>
  <div class="tab-nav">
    <div class="tabnav-warp">
      <div class="tab-list">
        <div>
          <span :class="{'active': curTab == item.productCateId}" v-for="item in tabList" :key="item.productCateId" :style="{color: item.titleColor}" @click="changeTab(item, $event)">{{item.name}}</span>
        </div>
      </div>
      <div class="tab-fixed" :class="{'tab-fixed-before': tabList.length > 6}" @click="goPage('/category')">
        <img v-if="tabListFixed.iconUrl" class="svg-icon" :src="tabListFixed.iconUrl | imageToHttps | imageToWebp($webpSurpport)" />
        <svg-icon v-else className="svg-icon" svg-path="assets/svgs/home/home_fenlei.svg" xlink="home_fenlei"></svg-icon>
        <span :style="{color: tabListFixed.titleColor}">{{tabListFixed.title}}</span>
      </div>
    </div>
    <div id="tabNav" class="tab-bg"></div>
  </div>
</template>

<script>
export default {
  name: 'tabNav',
  props: ['tabList', 'tabListFixed', 'curTab'],
  methods: {
    changeTab(item, event) {
      this.$emit('changeTab', item, event)
    },
    goPage(path) {
      this.$router.push(path)
    },
  }
}
</script>

<style lang="scss" scoped>

.tab-nav{
  position: relative;
  color: #666;
  height: .8rem;
  box-sizing: border-box;
  overflow: hidden;
}
.tabnav-warp{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: .18rem .32rem;
  z-index: 2;
}

.tab-bg{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1.68rem;
  z-index: 1;
}

.tab-nav-fixed{
  position: fixed;
  left: 0;
  right: 0;
  top: 1.75rem;
  z-index: 5;
  @include max-width;
}

.tab-list{
  height: .42rem;
  padding-right: 1rem;
  > div{
    height: .5rem;
    overflow-x: auto;
    white-space: nowrap;
    > span{
      margin-right: .4rem;
      display: inline-flex;
      height: .42rem;
      align-items: center;
      font-size: 17px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.4);
      &.active{
        color: rgba(51, 51, 51, 1);
        position: relative;
        &::after {
          content: ' ';
          display: block;
          width: 20px;
          height: 4px;
          background-color: $themeSynMain;
          border-radius: 2px;
          position: absolute;
          bottom: -4px;
          left: 50%;
          margin-left: -10px;
        }
      }
    }
  }
}

.tab-fixed{
  position: absolute;
  right: .32rem;
  top: .2rem;
  padding-left: .2rem;
  height: .42rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  font-size: .24rem;
}
.tab-fixed-before{
  &::before{
    content: '';
    position: absolute;
    top: 0;
    left: -.1rem;
    width: .1rem;
    height: .42rem;
    background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.15) 100%);
  }
}
.svg-icon{
  width: .32rem;
  height: .32rem;
}
</style>
